import { useContext, useEffect, useMemo, useState } from "react";
import { VisibilityOutlined } from "@mui/icons-material";
import ProductOptions from "./ForOrderOptions/ProductOptions";
import { CurrentPContext, MasterContext, OrderContext } from "../../ContextApi/context";
import TheMount from "../../OrderSettings/TheMount";
import ConnUrls from "../../Connections/ConnectURL";
import ProductComboOptions from "./ForOrderOptions/ProductComboOptions";
import TheWeightSelect from "../../OrderSettings/TheWeightSelect";
import ProductIngredientsView from "./ProductIngredientsView";
import OrderFunctions from "../../OrderSettings/OrderFunctions";

const ProductItemDeskTopMarket = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [master] = useContext(MasterContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [duplicates, setDuplicates] = useState([]);
    const [btnAddToOrder, setBtnAddToOrder] = useState({ txt: "הוסף להזמנה", ordID: -1 });
    const [sizeOfimg, setSizeOfimg] = useState("small");
    const [imInOrder, setImInOrder] = useState(false);
    const [popMeUp, setPopMeUp] = useState({ timestamp: 0, itemId: null });
    const [inOrderIndex, setInOrderIndex] = useState(-1);
    const [showIngredients, setShowIngredients] = useState(false);
    const isOutOfStock = !props.divitm.inStock || false;

    const hasIngredients = useMemo(() => {
        try {
            const p = JSON.parse(props.divitm.moreProductDetails);
            return !!p && typeof p === 'object' && !Array.isArray(p);
        } catch (e) { return false; }
    }, [props.divitm.moreProductDetails]);
    let specials = [];
    let mountToOrd = 0;
    let addsPrice = 0;

    useEffect(() => {
        if (props.autoOpenOptions) {
            firstTimeOrdClick();
        }
    }, []);

    useEffect(() => {
        let chkInOrder = (order.restId == currentPage._id);
        if (chkInOrder) {
            let getItm = order.Orders.findIndex(
                el => el.ordProdID == props.itemId &&
                    (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId))

            if (getItm != -1) {
                if (!imInOrder) {
                    setInOrderIndex(getItm);
                    setSizeOfimg("big");
                    setImInOrder(true);
                }
            } else {
                if (imInOrder) {
                    setImInOrder(false);
                    setSizeOfimg("small");
                    setInOrderIndex(-1);
                }
            }
        }
    }, [order]);

    const tempOrderProds = (prods, calculatedAddsPrice = null) => {
        let tempAddsPrice = 0;

        if (calculatedAddsPrice !== null) {
            tempAddsPrice = calculatedAddsPrice;
        } else {
            // חשב עם itmsMount
            prods.map((item, index) => {
                item.spec.map((prc, ind) => {
                    tempAddsPrice = parseInt(tempAddsPrice) +
                        (parseInt(prc.addToPrice != "" ? prc.addToPrice : 0) * parseInt(prc.itmsMount || 1));
                })
            })
        }

        specials = prods;
        addsPrice = tempAddsPrice;
    }

    const addDuplicate = () => {
        setPopMeUp({ timestamp: 0, itemId: null });

        const newItemId = `${props.itemId}_dup_${Date.now()}`;

        let newDivItem = JSON.parse(JSON.stringify(props.divitm));

        if (newDivItem.prodOptions) {
            newDivItem.prodOptions = newDivItem.prodOptions.map(opt => ({
                ...opt,
                selected: Array.isArray(opt.selected) ? [] : 0
            }));
        }

        setDuplicates([...duplicates,
        <ProductItemDeskTopMarket
            key={newItemId}
            itemId={newItemId}
            divitm={newDivItem}
            doDeliver={props.doDeliver}
            doTakeAway={props.doTakeAway}
            onlyPhone={props.onlyPhone}
            myClass=""
            smallMarketCss={props.smallMarketCss}
            autoOpenOptions={true}
        />
        ]);
    }

    const firstTimeOrdClick = () => {
        if (isOutOfStock) return;
        setImInOrder(true);
        addToOrder();
        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
    }

    const addToOrder = () => {
        let tmp = {
            ordProdID: props.itemId,
            productName: props.divitm.prodName,
            prodImageUrl: props.divitm.prodImageUrl,
            prodPrice: props.divitm.prodPrice,
            addsPrice: addsPrice,
            specials: specials,
            mount: parseInt(mountToOrd) + 1,
            weightValue: props.divitm.isWeightAbleProduct
                ? parseInt(props.divitm.weightValue)
                : undefined,
            baseWeightValue: props.divitm.isWeightAbleProduct
                ? parseInt(props.divitm.weightValue)
                : undefined,
            orderItemId: props.itemId,
            cashRegMakat: props.divitm.cashRegMakat,
            orderDiviId: props.divitm._id,
            isCombo: props.divitm.isCombo ? props.divitm.isCombo : false,
            chkProdSauces: props.divitm.chkProdSauces ? props.divitm.chkProdSauces : false,
            chkProdValSauces: props.divitm.chkProdValSauces ? props.divitm.chkProdValSauces : "",
            prodInfo: props.divitm.prodInfo || "",
            unitPrice: props.divitm.unitPrice
        };

        // רשת ביטחון מפני סל מעורב: אם הסל עדיין שייך לעסק אחר, פותחים סל
        // חדש במקום לערבב מוצרים משני עסקים תחת הזמנה אחת.
        // בזרימה תקינה הלקוח כבר נשאל על כך בכניסה לעמוד (RestaurantPage).
        if (OrderFunctions.cartBelongsToOtherRest(order, currentPage._id)) {
            order.Orders = [];
        }

        order.Orders.push(tmp);
        setInOrderIndex(order.Orders.length - 1);

        order.restId = currentPage._id;
        order.restName = currentPage.buissName;
        order.GoogleLink = currentPage.GoogleLink;
        setOrder({ ...order });
    }

    const removeFromOrder = (ordItmId) => {
        setImInOrder(false);
        setPopMeUp({ timestamp: 0, itemId: null });

        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId)
        order.Orders = filt;
        setOrder({ ...order })
    }

    const smDisp = () => {
        let imgLnk = `${(props.divitm.prodImageUrl != null && props.divitm.prodImageUrl != "") ? props.divitm.prodImageUrl
            : (currentPage.mnuItemMainImg != null && currentPage.mnuItemMainImg != "") ? currentPage.mnuItemMainImg : ""}`
        imgLnk = (imgLnk != "") ? ConnUrls.media(imgLnk) : "";

        return (
            <div id={`prodBlockS_${props.itemId}`} key={duplicates.length}
                className={`superMktProd grayFrame ${props.smallMarketCss} ${imInOrder ? "inOrderProd" : ""} ${isOutOfStock ? 'outOfStock' : ''}`}>

                {hasIngredients && (
                    <button className="prodEyeBtn" aria-label="הצג מרכיבים" onClick={(e) => { e.stopPropagation(); setShowIngredients(true); }}>
                        <VisibilityOutlined aria-hidden="true" />
                    </button>
                )}
                {imgLnk != "" &&
                    <div className={`prodImageWrap prodImageWrapSmall`}>
                        <img className={"prodImage"} src={imgLnk} alt={currentPage.altTags || currentPage.pageName || ""} />
                    </div>
                }

                <div className={"prodDetails"}>
                    <div className={`MyFont mnuDivPrdcbold MbigFont`}>
                        {props.divitm.prodName}{(imInOrder) ?
                            <>
                                <div className={"imInOrdBtn"}> אני בהזמנה </div>
                                <div className="dskMountItm">
                                    {props.divitm.isWeightAbleProduct ? (
                                        <div className="plusMinDeskTop">
                                            <TheWeightSelect
                                                itemId={props.itemId}
                                                weightValue={props.divitm.weightValue}
                                                remFromOrder={() => removeFromOrder(props.itemId)}
                                            />
                                        </div>
                                    ) : (
                                        <div className="plusMinDeskTop">
                                            <TheMount
                                                itemId={props.itemId}
                                                remFromOrder={() => removeFromOrder(props.itemId)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                            : ""}
                    </div>
                    <div className={"prodDetailsLong spaceTopBig"}>
                        <div className={"mnuDivPrdcReg"}>{props.divitm.prodInfo}</div>
                    </div>

                    {props.divitm.unitPrice &&
                        <div className={"prodDetailsLong"}>
                            <div className={"mnuDivPrdcReg"}> ₪{props.divitm.unitPrice}</div>
                        </div>
                    }
                    <div className={"deskPriceANdBtns"}>
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver && !isOutOfStock) ?
                            <div>
                                {(props.onlyPhone || props.myClass == null) ? "" :
                                    (imInOrder) ?
                                        <></>
                                        :
                                        <button type="button" className={"btnReset addToOrderBtn pointing"}
                                            aria-label="הוסף להזמנה"
                                            style={{ display: `${imInOrder ? "none" : "block"} ` }}
                                            onClick={() => firstTimeOrdClick()}>{" + "}
                                        </button>
                                }
                                <div className={"priceln "}>
                                    ₪{(() => {
                                        if (imInOrder && props.divitm.isWeightAbleProduct) {
                                            let item = order.Orders.find(el => el.ordProdID == props.itemId && (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId));
                                            if (item?.weightValue) {
                                                return ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2);
                                            }
                                        }
                                        return parseFloat(props.divitm.prodPrice).toFixed(2);
                                    })()}
                                </div>
                            </div> : ""
                        }
                    </div>
                </div>
            </div >
        )
    }

    return (
        <div key={props.itemId} id={props.itemId} className={`${props.myClass} `} style={{ position: "relative" }}>
            {props.myClass && <div className={"overLay"}></div>}
            <div className={"prods"}>
                {smDisp()}
            </div>
            <div className={"duplis"}>
                {duplicates}
            </div>
            {showIngredients && (
                <ProductIngredientsView
                    open={showIngredients}
                    onClose={() => setShowIngredients(false)}
                    prodName={props.divitm.prodName}
                    moreProductDetails={props.divitm.moreProductDetails}
                />
            )}
        </div>
    );
}

export default ProductItemDeskTopMarket;